export const COVERAGE_TYPES = {
  PERSONAL: 'Personal',
  CFI: 'CFI',
}
